import { Link } from "@tanstack/react-router";
import { WaitlistForm } from "./WaitlistForm";
import styles from "./MarketingLanding.module.scss";

// Placeholder copy graduated from the prototype-gate "Quiet photographic"
// variant. Final wording from the writer brief lands in a follow-up; tone is
// already aligned (warm-utilitarian, no emoji greetings, no "Discover your
// next adventure"-isms).
const COPY = {
  eyebrow: "Plotlounge — in-person book clubs",
  headline: "Read the book. Show up. Talk about it.",
  lede: "Small reading groups in your city. Pick a gathering, RSVP with your email, bring the book. That's the whole product.",
  primaryCta: "Find a gathering near you",
  heroPhotoCaption: "Park Slope Reads · Lulu's on 5th",
  footEyebrow: "Coming to more cities",
  footTitle: "Tell us where you read.",
  footMeta: "We'll only email when we open in your city.",
};

export function MarketingLanding() {
  return (
    <main className={styles.root}>
      <header className={styles.topbar}>
        <span className={styles.wordmark}>Plotlounge</span>
        <Link to="/sign-in" className={styles.signin}>
          Sign in
        </Link>
      </header>

      <section className={styles.hero}>
        <div className={styles.heroPhoto} aria-hidden>
          <div className={styles.heroPhotoCaption}>{COPY.heroPhotoCaption}</div>
        </div>
        <div className={styles.heroCopy}>
          <p className={styles.eyebrow}>{COPY.eyebrow}</p>
          <h1 className={styles.headline}>{COPY.headline}</h1>
          <p className={styles.lede}>{COPY.lede}</p>
          {/* /discover is registered in PR 5; until then this anchor is a
              full-page nav so it works the moment the route lands. */}
          <a href="/discover" className={styles.primaryCta}>
            {COPY.primaryCta} →
          </a>
        </div>
      </section>

      <footer className={styles.foot}>
        <p className={styles.footEyebrow}>{COPY.footEyebrow}</p>
        <h2 className={styles.footTitle}>{COPY.footTitle}</h2>
        <WaitlistForm source="marketing" />
        <p className={styles.footMeta}>{COPY.footMeta}</p>
        <div className={styles.footLinks}>
          <span>© Plotlounge {new Date().getFullYear()}</span>
        </div>
      </footer>
    </main>
  );
}
